import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function CreatePage() {
  const navigate = useNavigate();
  const [hostName, setHostName] = useState('');
  const [targetPoints, setTargetPoints] = useState(5);
  const [submissionTime, setSubmissionTime] = useState(60);
  const [votingTime, setVotingTime] = useState(30);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = async () => {
    const name = hostName.trim();
    if (!name) {
      setError('Enter your name');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/session/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          gameType: 'gambit',
          hostName: name,
        }),
      });

      if (!res.ok) {
        throw new Error('Failed to create session');
      }

      const data = await res.json();

      // Store session info and navigate to game
      const params = new URLSearchParams({
        playerId: data.hostId,
        host: '1',
        targetPoints: String(targetPoints),
        submissionTime: String(submissionTime),
        votingTime: String(votingTime),
      });
      navigate(`/game/${data.sessionCode}?${params}`);
    } catch {
      setError('Failed to create game. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-100 px-4">
      <div className="max-w-md w-full">
        <button onClick={() => navigate('/')} className="btn btn-ghost btn-sm mb-6">
          &larr; Back
        </button>

        <h1 className="text-3xl font-bold mb-8">Create Game</h1>

        <div className="space-y-6">
          <div className="form-control">
            <label className="label">
              <span className="label-text text-lg">Your Name</span>
            </label>
            <input
              type="text"
              placeholder="Enter your name"
              value={hostName}
              onChange={(e) => setHostName(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
              className="input input-bordered w-full"
              maxLength={20}
              autoFocus
            />
          </div>

          <div className="form-control">
            <label className="label">
              <span className="label-text">Points to Win</span>
              <span className="label-text-alt text-lg font-bold">{targetPoints}</span>
            </label>
            <input
              type="range"
              min={3}
              max={20}
              value={targetPoints}
              onChange={(e) => setTargetPoints(Number(e.target.value))}
              className="range range-primary range-sm"
            />
            <div className="flex justify-between text-xs text-base-content/40 px-1 mt-1">
              <span>3</span>
              <span>20</span>
            </div>
          </div>

          <div className="form-control">
            <label className="label">
              <span className="label-text">Submission Time</span>
              <span className="label-text-alt text-lg font-bold">{submissionTime}s</span>
            </label>
            <input
              type="range"
              min={15}
              max={120}
              step={5}
              value={submissionTime}
              onChange={(e) => setSubmissionTime(Number(e.target.value))}
              className="range range-secondary range-sm"
            />
          </div>

          <div className="form-control">
            <label className="label">
              <span className="label-text">Voting Time</span>
              <span className="label-text-alt text-lg font-bold">{votingTime}s</span>
            </label>
            <input
              type="range"
              min={10}
              max={60}
              step={5}
              value={votingTime}
              onChange={(e) => setVotingTime(Number(e.target.value))}
              className="range range-accent range-sm"
            />
          </div>

          {error && (
            <div className="alert alert-error">
              <span>{error}</span>
            </div>
          )}

          <button
            onClick={handleCreate}
            disabled={loading || !hostName.trim()}
            className="btn btn-primary btn-lg w-full"
          >
            {loading ? <span className="loading loading-spinner" /> : 'Create Game'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreatePage;
